var map = {
	"./bell.svg": "3d56",
	"./eye.svg": "7364",
	"./google.svg": "d950",
	"./googleIcon.svg": "a67d",
	"./hide-eye.svg": "068e",
	"./info.svg": "76ed",
	"./microsoft.svg": "7b25",
	"./microsoftIcon.svg": "18d9",
	"./switch.svg": "221d",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";